/**
 * StatusBadgeV2 Component
 * Colored pill badge: ENROUTE AS{n}, AT AS{n}, ENROUTE FINISH, FINISHED, DNF, DNS, WAITING (Pencil `Ih3cY`)
 */

import type { RunnerStatus } from '../../lib/types';

interface StatusBadgeV2Props {
  status: RunnerStatus;
  label: string;
}

function getBadgeClass(status: RunnerStatus, label: string): string {
  switch (status) {
    case 'on_course':
      // Split on_course by phase: AT = green (check-in), ENROUTE = blue (check-out).
      // Match the project color system used on bubbles and elsewhere.
      if (label.startsWith('AT ')) return 'v2-badge--at-station';
      if (label.startsWith('ENROUTE')) return 'v2-badge--enroute';
      return 'v2-badge--on-race';
    case 'finished':
      return 'v2-badge--finished';
    case 'dropped':
      return 'v2-badge--dnf';
    case 'dns':
      return 'v2-badge--dns';
    default:
      return 'v2-badge--on-race';
  }
}

export function StatusBadgeV2({ status, label }: StatusBadgeV2Props) {
  return (
    <span className={`v2-badge ${getBadgeClass(status, label)}`}>
      {label}
    </span>
  );
}
